import { combineReducers } from 'redux';
import authReducer from './authReducer';
import sitesReducer from './sitesReducer';
import pageLoadingReducer from './pageLoadingReducer';
import queryLoadingReducer from './queryLoadingReducer';
import pagesRawReducer from './pagesRawReducer';
import pagesSearchReducer from './pagesSearchReducer';
import startDateReducer from './startDateReducer';
import endDateReducer from './endDateReducer';
import focusedInputReducer from './focusedInputReducer';
import queriesReducer from './queriesReducer';
import isPageActiveReducer from './isPageActiveReducer';
import pageMetricsByDateReducer from './pageMetricsByDateReducer';
import selectedMetricReducer from './selectedMetricReducer';
import selectedPageReducer from './selectedPageReducer';
import queryMetricsByDateReducer from './queryMetricsByDateReducer';
import selectedQueryReducer from './selectedQueryReducer';
import isQueryActiveReducer from './isQueryActiveReducer';
import pageCountReducer from './pageCountReducer';
import queriesCountReducer from './queriesCountReducer';
import positionFilterReducer from './positionFilterReducer';
import activeQueryPageNumReducer from './activeQueryPageNumReducer';
import dataStartReducer from './dataStartReducer';
import dataEndReducer from './dataEndReducer';
import countryListReducer from './countryListReducer';
import deviceListReducer from './deviceListReducer';
import countryReducer from './countryReducer';
import titleTagReducer from './titleTagReducer';
import metaDescriptionReducer from './metaDescriptionReducer';
import pageMetaReducer from './pageMetaReducer';
import selectedSiteReducer from './selectedSiteReducer';
import siteListReducer from './siteListReducer';
import h1Reducer from './h1Reducer';
import occurrenceReducer from './occurrenceReducer';
import keywordDensityReducer from './keywordDensityReducer';
import queriesFiveWToggleReducer from './queriesFiveWToggleReducer';
import copiedReducer from './copiedReducer';
import titleLenReducer from './titleLenReducer';
import metaDescLenReducer from './metaDescLenReducer';
import deviceReducer from './deviceReducer';
import activePageNumReducer from './activePageNumReducer';
import dataStorageProgressReducer from './dataStorageProgressReducer';
import pageSortMetricReducer from './pageSortMetricReducer';
import querySortMetricReducer from './querySortMetricReducer';
import pageOrderDirectionReducer from './pageOrderDirectionReducer';
import queryOrderDirectionReducer from './queryOrderDirectionReducer';
import queriesPaginatedReducer from './queriesPaginatedReducer';
import queriesRawReducer from './queriesRawReducer';
import keywordVolumeReducer from './keywordVolumeReducer';
import datePresetReducer from './datePresetReducer';
import chartToggleReducer from './chartToggleReducer';
import adminUsersToAddReducer from './adminUsersToAddReducer';
import adminUsersToRemoveReducer from './adminUsersToRemoveReducer';
import errorReducer from './errorReducer';
import exportLoadingReducer from './exportLoadingReducer';
import exportDataReducer from './exportDataReducer';
import paymentConfirmationReducer from './paymentConfirmationReducer';
import unsubscribeConfirmationReducer from './unsubscribeConfirmationReducer';

export default combineReducers({
  auth: authReducer,
  sites: sitesReducer,
  pageLoading: pageLoadingReducer,
  queryLoading: queryLoadingReducer,
  pages: pagesRawReducer,
  pagesSearch: pagesSearchReducer,
  startDate: startDateReducer,
  endDate: endDateReducer,
  focusedInput: focusedInputReducer,
  queries: queriesReducer,
  isPageActive: isPageActiveReducer,
  pageMetricsByDate: pageMetricsByDateReducer,
  selectedMetric: selectedMetricReducer,
  selectedPage: selectedPageReducer,
  queryMetricsByDate: queryMetricsByDateReducer,
  selectedQuery: selectedQueryReducer,
  isQueryActive: isQueryActiveReducer,
  pageCount: pageCountReducer,
  queriesCount: queriesCountReducer,
  positionFilter: positionFilterReducer,
  activeQueryPageNum: activeQueryPageNumReducer,
  dataStart: dataStartReducer,
  dataEnd: dataEndReducer,
  countryList: countryListReducer,
  country: countryReducer,
  titleTag: titleTagReducer,
  metaDescription: metaDescriptionReducer,
  pageMeta: pageMetaReducer,
  selectedSite: selectedSiteReducer,
  siteList: siteListReducer,
  h1: h1Reducer,
  occurrence: occurrenceReducer,
  keywordDensity: keywordDensityReducer,
  queriesFiveWToggle: queriesFiveWToggleReducer,
  copyToast: copiedReducer,
  titleLength: titleLenReducer,
  metaDescLen: metaDescLenReducer,
  device: deviceReducer,
  activePageNum: activePageNumReducer,
  dataStorageProgress: dataStorageProgressReducer,
  deviceList: deviceListReducer,
  pageSortMetric: pageSortMetricReducer,
  querySortMetric: querySortMetricReducer,
  pageOrderDirection: pageOrderDirectionReducer,
  queryOrderDirection: queryOrderDirectionReducer,
  queriesPaginated: queriesPaginatedReducer,
  queriesRaw: queriesRawReducer,
  keywordVolume: keywordVolumeReducer,
  datePreset: datePresetReducer,
  chartToggle: chartToggleReducer,
  adminUsersToAdd: adminUsersToAddReducer,
  adminUsersToRemove: adminUsersToRemoveReducer,
  error: errorReducer,
  exportLoading: exportLoadingReducer,
  exportData: exportDataReducer,
  paymentConfirmation: paymentConfirmationReducer,
  unsubscribeConfirmation: unsubscribeConfirmationReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js